<template>
<div>
  <zoo-header-text v-if="kind=='zoo'"></zoo-header-text>
  <anatomist-header-text v-if="kind=='anatomist'"></anatomist-header-text>
  <pathologist-header-text v-if="kind=='pathologist'"></pathologist-header-text>
  <b-row class="text-center">
    <b-col>
      <h1 class="my-3">Datasets</h1>
    </b-col>
  </b-row>
  <b-row v-for="(project, pindex) in projects" :key="pindex">
    <b-col>
      <span class="dbb-red"><h2>{{ project.projectTitle }}</h2></span>
      <h5>{{ project.projectDescription }}</h5>
      <dataset
        v-for="(dataset, dindex) in project.datasets" :key="dindex"
        :dataset="dataset"
        class="mx-2"
      >
      </dataset>
    </b-col>
  </b-row>
  
  
</div>
  
</template>

<script>
//import * as dbblib from "@/dbblib.js"
import axios from 'axios'
import Dataset from "@/components/Dataset.vue";
import ZooHeaderText from "@/components/ZooHeaderText.vue"
import PathologistHeaderText from "@/components/PathologistHeaderText.vue"
import AnatomistHeaderText from "@/components/AnatomistHeaderText.vue"
export default {
  name: "dataPage",
  components: {
    Dataset,
    ZooHeaderText,
    PathologistHeaderText,
    AnatomistHeaderText
  },
  data () {
    return {
      datasets: [],
      projects: [],
      kind: ''
    }
  },
  methods: {
    getDatasets() {
     axios.get('/DigitalBrainBank/datasets', {
        params: {
          category: this.kind
        }
      })
      .then((response) => {
        console.log(response)
        if ('success' in response.data){
          var datasets = response.data.success
          this.datasets = datasets.filter((item) => {
            return item.isVisible === true && item.category === this.kind
          })
          this.sortByProject()
        } else {
          console.log(response.data)
        }
      }, (error) => {
        console.log(error)
      }) 
    },

    sortByProject() {
      var projects = []
      var projectTemplate = {projectTitle: '', projectDescription: ''}
      if (this.datasets.length === 0) {
        return
      }
      for (var i = 0; i<this.datasets.length; i++) {
        var proj = Object.create(projectTemplate)
        proj.projectTitle = this.datasets[i].projectTitle
        proj.projectDescription = this.datasets[i].projectDescription
        projects.push(proj)
      }
      
      var uniqueProjects = Array.from(new Set(projects.map(elem => elem.projectTitle)))
      .map(projectTitle => {
        return {
          projectTitle: projectTitle,
          projectDescription: projects.find(elem => elem.projectTitle === projectTitle).projectDescription
        }
      })
      console.log(uniqueProjects)

      for (var j=0; j<uniqueProjects.length; j++) {
        var u_proj = uniqueProjects[j].projectTitle
        //console.log(u_proj)
        this.projects.push({
          projectTitle: u_proj,
          projectDescription: uniqueProjects[j].projectDescription,
          datasets: []
        })
        for (var k=0; k<this.datasets.length; k++){
          var dataset_proj = this.datasets[k].projectTitle
          if (dataset_proj === u_proj) {
            this.projects[j].datasets.push(this.datasets[k])
          }
        }
        this.projects[j].datasets.sort((a, b) => (a.datasetTitle.toLowerCase()> b.datasetTitle.toLowerCase()) ? 1 : -1)
      }
      this.projects.sort((a, b) => (a.projectTitle.toLowerCase() > b.projectTitle.toLowerCase()) ? 1 : -1)
      //console.log(this.projects)
    }
    
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        location.reload()
      }
      //this.kind = this.$route.params.kind
    }
  },
  mounted () {
    this.kind = this.$route.params.kind
    this.getDatasets()

  }

  
}
</script>

<style scoped>
.dbb-red {
  color: #8b2a34;
}
</style>
